import React, { FC, SVGProps } from 'react';

export const LowCost: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="#B1CB8F" />
    <path d="M32 36H49L41.5 57.5L38.5 57L32 36Z" fill="#FFCFAD" />
    <path
      d="M21.9947 38.3936C20.8218 36.9862 20.755 34.9618 21.8326 33.4802L26.0747 27.6473C26.8274 26.6123 28.0299 26 29.3096 26H50.6904C51.9701 26 53.1726 26.6123 53.9253 27.6473L58.1674 33.4802C59.245 34.9618 59.1782 36.9862 58.0053 38.3936L43.0729 56.3125C41.4737 58.2316 38.5263 58.2316 36.9271 56.3125L21.9947 38.3936Z"
      stroke="#26313B"
      strokeWidth="2"
    />
    <path d="M28 27L39 57.5" stroke="#26313B" strokeWidth="2" />
    <path d="M52 27L41 57.5" stroke="#26313B" strokeWidth="2" />
    <path d="M58.5 35.5H21.5" stroke="#26313B" strokeWidth="2" />
  </svg>
);
